import React, { useState, useEffect, useRef } from "react";
import Navbar from "./Navbar/Navbar";
import arrowLeft from "../assets/Images/arrowL.png";
import arrowRight from "../assets/Images/arrowR.png";
import axios from "axios";
import SvgRender from './SvgRender'

const GalleryPage = () => {
  const [initLogo, setInitLog] = useState(0);
  const [svgData, setSvgData] = useState([]);
  const [colors, setColors] = useState([]);
  const [fonts, setFonts] = useState([]);
  
  
  useEffect(() => {
    axios
      .get("https://api.izeelogo.com/frontend?code=weOneIT2022")
      .then((res) => {
        let arr = [];
        res.data.map((item, index) => {
          arr.push({ id: index, content: item.content });
        });
        setSvgData(arr);
      })
      .catch((err) => {
        console.log("endpoint Err", err);
      });
  }, []);


  
  useEffect(() => {
   if (svgData.length>0) {
    let style =  document.querySelector('#svC svg defs style')
    let colorsArr=[]
    let fontsArr=[]
    for (var i = 0; i < style.sheet.cssRules.length; i++) {
      if (style.sheet.cssRules[i].style.fill) {
        colorsArr.push(style.sheet.cssRules[i].style.fill)
      }
      if (style.sheet.cssRules[i].style.fontFamily) {
        fontsArr.push(style.sheet.cssRules[i].style.fontFamily)
      }
    }
    setColors(colorsArr) 
    setFonts(fontsArr)
   }
  }, [svgData, initLogo]);


  
  const next = () => {
    if (initLogo + 1 === svgData.length) {
      setInitLog(0);
    } else {
      setInitLog(initLogo + 1);
    }
  };

  const prev = () => {
    if (initLogo === 0) {
      setInitLog(svgData.length - 1);
    } else {
      setInitLog(initLogo - 1);
    }
  };

  return (
    <section className="w-full overflow-x-hidden relative px-5 pb-[74px] ">
      <Navbar active="Gallery" />

      <div className="flex md:flex-row flex-col-reverse gap-5 items-start">
        <div className="w-full md:w-1/2 flex flex-row md:flex-col ">
          <div className="w-1/2 md:w-full ">
            <h2
              className="md:text-[20px] text-[16px] font-bold font-Play text-left 
              tracking-wide md:leading-tight
              leading-snug mb-[20px] md:mb-[25px] "
            >
              {" "}
              Color Palette
            </h2>

            <div className="flex flex-row gap-5 mr-2 flex-wrap mb-[45px] ">
              {colors && colors.length > 0  &&
                 colors.map((color, index) => (
                  <div key={index}
                    className={`w-12 h-12`}
                    style={{ backgroundColor: color }}
                  ></div>
                ))}
            </div>
          </div>

          <div className="w-1/2 md:w-full">
            <h2
              className="md:text-[20px] text-[16px] font-bold font-Play text-left 
              tracking-wide md:leading-tight
              leading-snug mb-[20px] md:mb-[25px] "
            >
              {" "}
              Fonts
            </h2>

            <ul className="flex flex-col items-start text-left mt-4 gap-2 ">
              {fonts && fonts.length > 0  &&
                  fonts.map((font, index) => (
                <li key={index} className="relative 
                font-Play text-[16px] 
                before:absolute before:w-1 before:h-1
                 before:bg-[#3B65FF] before:-left-3 before:top-1/2 before:rounded-full ml-3 ">
                  {font}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="relative w-full md:w-1/2  flex justify-center items-center mb-[35px]
          md:mb-0
        ">
          {/* h-[85vw] md:h-[22rem] md:w-[22rem] */}
          <div
            className="w-full flex flex-col justify-center 
            max-w-[360px] max-h-[400px] 
              md:ml-auto"
          >
            <div  className=" border-2  h-full w-full  p-5">
            {svgData && svgData.length > 0 && (
              <SvgRender  id='svC' svg={svgData[initLogo].content} />
            )}
              
            </div>
            <div className="flex justify-between mt-8 md:mt-5">
              <img
                src={arrowLeft}
                alt="prec"
                className="cursor-pointer opacity-90 hover:opacity-100"
                onClick={() => prev()}
              />
              <img
                src={arrowRight}
                alt="next"
                className="cursor-pointer opacity-90 hover:opacity-100"
                onClick={() => next()}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GalleryPage;